import { GMGrimoire } from "../../../../shared/Grimoire/GrimoireView";

export interface GrimoireCircleTabProps {}

export function GrimoireCircleTab(_props: GrimoireCircleTabProps) {
  return (
    <>
      <GMGrimoire hideCenter />
    </>
  );
}
